import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from 'semantic-ui-react';

import Container from '../../layout/Container';
import SectionTitle from '../SectionTitle/SectionTitle';
import TestimonialItem from '../Testimonials/TestimonialItem';
import { translateLocal } from '../../../i18n';

import './TestimonialsBlock.scss';

const styles = {
  courseRow: {
    margin: '1rem 0',
    padding: 0,
  },
};

const TestimonialsBlock = ({
  black, data, pageData,
}) => (
  <div className={`satisfied-block ${black ? 'black' : ''}`} id="testimonials">
    <Container className="intro">
      <SectionTitle
        title={translateLocal(pageData.title)}
        subtitle={translateLocal(pageData.subtitle)}
      />

      <Grid columns={3} stackable>
        <Grid.Row style={styles.courseRow}>
          {data.map((item, index) => (
            <Grid.Column key={index}>
              <TestimonialItem
                name={item.name}
                text={translateLocal(item.text)}
                rating={item.rating}
              />
            </Grid.Column>
          ))}
        </Grid.Row>
      </Grid>
    </Container>
  </div>
);

TestimonialsBlock.propTypes = {
  black: PropTypes.bool,
  data: PropTypes.array.isRequired,
  pageData: PropTypes.object.isRequired,
};

TestimonialsBlock.defaultProps = {
  black: false,
};

export default TestimonialsBlock;
